<template>
  <v-container id="city-get">
    <city-header :payload="payload" v-if="isAuthenticated" @realod="loadFirst">
    </city-header>

    <v-row>
      <v-col md="9" sm="9" lg="9">
        <v-card>
          <v-card-text v-if="!isAT">
            <h4>EVOLUÇÃO DO MUNICÍPIO</h4>
            <v-divider> </v-divider>

            <v-row
              v-if="
                isFullAdmin ||
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  (payload.statusId === statusRelacionamentoEnum.vigente ||
                    (isSala &&
                      payload.statusId ===
                        statusRelacionamentoSeloEnum.participante)))
              "
            >
              <v-col cols="1">
                <v-icon color="primary"> mdi-chart-bar </v-icon>
              </v-col>

              <v-col cols="2" class="d-flex justify-content-center">
                <v-row align="center">
                  <span> Pontos Totais: {{ payload.pontos }} </span>
                </v-row>
              </v-col>

              <v-col sm="1">
                <v-icon color="primary"> mdi-medal </v-icon>
              </v-col>

              <v-col sm="2" class="d-flex justify-content-center">
                <v-row align="center">
                  <span> Medalhas: {{ payload.totalMedalhas }} </span>
                </v-row>
              </v-col>
            </v-row>

            <v-row style="display: flex">
              <v-col
                md="5"
                sm="5"
                lg="5"
                offset="1"
                v-if="
                  isFullAdmin ||
                  (config.visualizarPontosMedalha &&
                    groupsConfig.visualizarPontosMedalha &&
                    (payload.statusId === statusRelacionamentoEnum.vigente ||
                      (isSala &&
                        payload.statusId ===
                          statusRelacionamentoSeloEnum.participante)))
                "
              >
                <line-chart
                  :chart-data="lineChart"
                  :options="lineChartOptions"
                  :width="200"
                  :height="200"
                ></line-chart>
              </v-col>

              <v-col>
                <bar-chart
                  :chart-data="barChart"
                  :options="barChartOptions"
                  :width="200"
                  :height="200"
                ></bar-chart>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              v-if="
                (isFullAdmin ||
                  (config.visualizarPontosMedalha &&
                    groupsConfig.visualizarPontosMedalha &&
                    (payload.statusId === statusRelacionamentoEnum.vigente ||
                      (isSala &&
                        payload.statusId ===
                          statusRelacionamentoSeloEnum.participante)))) &&
                !isAT
              "
            >
              <v-col
                v-for="medalha in payload.medalhas"
                v-bind:key="medalha.municipioMedalhaId"
                cols="2"
              >
                <div
                  v-if="
                    medalha.medalha.imagemBronzeBlob ||
                    medalha.medalha.imagemBronze
                  "
                >
                  <img
                    :src="
                      medalha.medalha.imagemBronzeBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemBronzeBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemBronze
                    "
                    v-if="medalha.possui === false && showMedalGrey === true"
                    :width="medalWidth"
                    class="grayScale"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemOuroBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemOuroBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemOuro
                    "
                    v-if="medalha.possuiOuro"
                    :width="medalWidth"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemPrataBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemPrataBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemPrata
                    "
                    v-if="!medalha.possuiOuro && medalha.possuiPrata"
                    :width="medalWidth"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemBronzeBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemBronzeBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemBronze
                    "
                    v-if="!medalha.possuiPrata && medalha.possuiBronze"
                    v-bind:class="{ medalhas: !medalha.possui }"
                    :width="medalWidth"
                  />
                </div>
              </v-col>
            </v-row>

            <div v-if="estado === 'RJ1'">
              <h4>RELATÓRIO DO GESTOR</h4>
              <v-divider> </v-divider>

              <v-textarea
                v-model="payload.relatorioGestor"
                :disabled="!editReport"
                :readonly="!editReport"
              >
              </v-textarea>
              <v-divider> </v-divider>

              <v-col class="text-right">
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  v-if="editReport === true"
                  @click="updateReport()"
                >
                  SALVAR
                </v-btn>

                <v-btn
                  v-if="
                    isAdmin ||
                    isConsultorCondutorMunicipio ||
                    isADMunicipio ||
                    isConsultorEspecialistaMunicipio
                  "
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="editReport = !editReport"
                >
                  <span v-if="editReport === false"> EDITAR </span>
                  <span v-if="editReport === true"> CANCELAR </span>
                </v-btn>
              </v-col>
            </div>
          </v-card-text>
          <v-card-text v-if="isAT">
            <h4>SOBRE O MUNICÍPIO</h4>
            <v-divider> </v-divider>

            <v-row class="mt-4" style="min-height: 30vh">
              <v-col>
                {{ payload.descricao }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3" sm="3" lg="3">
        <v-row>
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              v-if="
                payload.diagnostico === false &&
                (isFullAdmin ||
                  (config.realizarDiagnostico &&
                    groupsConfig.realizarDiagnostico))
              "
              @click="openDiagnostic()"
            >
              RESPONDER DIAGNÓSTICO
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-modal-edit-city
              v-if="
                isFullAdmin ||
                (config.editarMunicipio && groupsConfig.editarMunicipio)
              "
              @save="loadCity()"
              :payload="payload"
              :edit="true"
            ></app-modal-edit-city>
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin ||
            (config.resumoMunicipio && groupsConfig.resumoMunicipio)
          "
        >
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="$router.push(`/cidade/${municipioId}/resumo-municipio`)"
            >
              RESUMO DO MUNICÍPIO
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="
            config.relatorioMensal &&
            groupsConfig.relatorioMensal &&
            !isIndicadores &&
            !isSala
          "
        >
          <v-col>
            <app-modal-report :municipioId="municipioId"> </app-modal-report>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="
                $router.push(`/cidade/${municipioId}/agenteTerritorial/ator`)
              "
              v-if="
                isAT &&
                (isFullAdmin ||
                  (config.agenteTerritorial && groupsConfig.agenteTerritorial))
              "
            >
              AGENTE TERRITORIAL
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="payload.linkMaps">
          <v-col>
            <v-btn outlined color="primary" class="ml-3" @click="openMaps()">
              ABRIR MAPS
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="payload.prefeito">
          <v-col md="12" sm="12" lg="12">
            <h5>SOBRE O MUNICÍPIO</h5>
            <v-divider></v-divider>
          </v-col>

          <v-col md="6" sm="6" lg="6" v-if="payload.prefeito">
            <h4>Prefeito</h4>
            <v-divider></v-divider>
            <span>{{ payload.prefeito }}</span>
          </v-col>

          <v-col md="6" sm="6" lg="6" v-if="payload.partido">
            <h4>Partido</h4>
            <v-divider></v-divider>
            <span>{{ payload.partido }}</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.populacao">
            <h4>População</h4>
            <v-divider></v-divider>
            <span>{{ payload.populacao }} Hab.</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.orcamento">
            <h4>Orçamento</h4>
            <v-divider></v-divider>
            <span>R$ {{ payload.orcamento }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.isdel">
            <h4>ISDEL</h4>
            <v-divider></v-divider>
            <span>{{ payload.isdel }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.idh">
            <h4>IDH</h4>
            <v-divider></v-divider>
            <span>{{ payload.idh }}</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.pib">
            <h4>PIB</h4>
            <v-divider></v-divider>
            <span>{{ payload.pib }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.densidadeDemografica">
            <h4>Densidade Demográfica</h4>
            <v-divider></v-divider>
            <span>{{ payload.densidadeDemografica }} Hab/Km²</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.rendaMedia">
            <h4>Renda Média</h4>
            <v-divider></v-divider>
            <span>R$ {{ payload.rendaMedia }}</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.receita">
            <h4>Receita</h4>
            <v-divider></v-divider>
            <span>R$ {{ payload.receita }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.area">
            <h4>Área KM²</h4>
            <v-divider></v-divider>
            <span>{{ payload.area }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.despesa">
            <h4>Despesa</h4>
            <v-divider></v-divider>
            <span>R$ {{ payload.despesa }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.tempoMedio">
            <h4>Tempo Médio Abertura de Empresas</h4>
            <v-divider></v-divider>
            <span>{{ payload.tempoMedio }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.numeroEmpresas">
            <h4>Empresas</h4>
            <v-divider></v-divider>
            <span>{{ payload.numeroEmpresas }}</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.me">
            <h4>ME e EPP</h4>
            <v-divider></v-divider>
            <span>{{ payload.me }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.mei">
            <h4>MEI</h4>
            <v-divider></v-divider>
            <span>{{ payload.mei }}</span>
          </v-col>
          <v-col md="4" sm="4" lg="4" v-if="payload.totalMEI">
            <h4>MEI / Total</h4>
            <v-divider></v-divider>
            <span>{{ payload.totalMEI }} %</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.ideb">
            <h4>IDEB</h4>
            <v-divider></v-divider>
            <span>{{ payload.ideb }}</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.docentesEF">
            <h4>Nº Docentes Educação Infantil</h4>
            <v-divider></v-divider>
            <span>{{ payload.docentesEF }}</span>
          </v-col>

          <v-col md="4" sm="4" lg="4" v-if="payload.alunosEF">
            <h4>Nº Alunos Educação Infantil</h4>
            <v-divider></v-divider>
            <span>{{ payload.alunosEF }}</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="4" sm="4" lg="4" v-if="payload.igm">
            <h4>IGM</h4>
            <v-divider></v-divider>
            <span>{{ payload.igm }} %</span>
          </v-col>
        </v-row>

        <v-row v-if="payload.atividades && payload.atividades.length > 0">
          <v-col md="12" sm="12" lg="12">
            <h3>Atividades Econômicas</h3>
            <v-divider></v-divider>
            <v-row
              v-for="atividade in payload.atividades"
              v-bind:key="atividade.municipioAtividadeId"
              align="center"
            >
              <v-col md="3" sm="3" lg="3">
                <v-avatar color="primary">
                  <v-icon color="white">
                    {{ atividade.atividade.icone }}
                  </v-icon>
                </v-avatar>
              </v-col>

              <v-col>
                {{ atividade.atividade.nome }}
              </v-col>
              <v-col> Participação: {{ atividade.percentual }} % </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalEditCity from "./ModalEdit";
import LineChart from "@/components/chart/LineChart";
import BarChart from "@/components/chart/BarChart";
import CityHeader from "./Header";
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalReport from "@/modules/report/components/ModalReport";
import AgenteTerritorial from "@/modules/agenteTerritorial/list";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
} from "@/types";

export default {
  components: {
    AppModalEditCity,
    LineChart,
    BarChart,
    CityHeader,
    AppModalReport,
    AgenteTerritorial,
  },
  data() {
    return {
      municipioId: this.$route.params.id,
      medalWidth: "135px",
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      showMedalGrey: false,
      payload: {
        acompanhamentos: [],
        temas: [],
      },
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      editReport: false,
      nomesAcompanhamentos: [],
      pontosAcompanhamentos: [],
      nomesTemas: [],
      percentuaisTemas: [],
      lineChart: {},
      lineChartOptions: {
        // onHover: (e) => {
        //   if (e.type == 'mousemove') {
        //     this.lineChartOptions.scales.xAxes[0].ticks.display = true
        //   } else if (e.type == 'mouseout') {
        //     this.lineChartOptions.scales.xAxes[0].ticks.display = false
        //   }
        // },

        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },

        responsive: true,
        maintainAspectRatio: false,
      },
      barChart: {},
      barChartOptions: {
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
              },
              ticks: {
                callback: function (label) {
                  if (label == null) {
                    return "";
                  }
                  if (label.length > 15) {
                    label = label.substring(0, 15);
                    label += "...";
                  }
                  return label;
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      estado: this.$store.state.uf,
    };
  },

  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
      "setCityName",
      "setCityId",
    ]),

    loadCity() {
      this.setLoading(true);

      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.payload = resp.data;
          this.setCityName(this.payload.nome);
          this.setCityId(this.payload.municipioId);

          this.nomesAcompanhamentos = this.payload.acompanhamentos.map(
            function (item) {
              return item.nome;
            }
          );

          this.pontosAcompanhamentos = this.payload.acompanhamentos.map(
            function (item) {
              return item.pontos;
            }
          );

          for (
            let count = 0;
            count < this.pontosAcompanhamentos.length;
            count++
          ) {
            if (count > 0)
              this.pontosAcompanhamentos[count] =
                this.pontosAcompanhamentos[count] +
                this.pontosAcompanhamentos[count - 1];
          }

          var temasPermissoes = this.payload.temas;

          if (!this.userTeste.grupo.verTodosEixos) {
            temasPermissoes = temasPermissoes.filter((item) =>
              this.userTeste.permissoes.some(
                (per) =>
                  per.eixoId === item.tema.eixoId &&
                  per.municipioId === item.municipioId
              )
            );

            this.payload.medalhas = this.payload.medalhas.filter((item) =>
              this.userTeste.permissoes.some(
                (per) =>
                  per.eixoId === item.medalha.temaId &&
                  per.municipioId === item.municipioId
              )
            );
          }

          this.nomesTemas = temasPermissoes.map(function (item) {
            return item.tema.nome;
          });

          this.percentuaisTemas = temasPermissoes.map(function (item) {
            return Math.ceil((item.pontos / item.tema.pontos) * 100);
          });

          this.setLoading(false);
          this.fillLineChart();
          this.fillBarChart();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },

    updateReport() {
      this.setLoading(true);
      cityAPI
        .update(this.payload)
        .then((resp) => {
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar relatório");
        });
    },
    openDiagnostic() {
      this.$router.push("/diagnostico/" + this.$route.params.id);
    },
    fillLineChart() {
      this.lineChart = {
        labels: this.nomesAcompanhamentos,
        datasets: [
          {
            backgroundColor: "#5C8AB9",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.pontosAcompanhamentos,
          },
        ],
      };
    },
    fillBarChart() {
      this.barChart = {
        labels: this.nomesTemas,
        datasets: [
          {
            backgroundColor: "#5C8AB9",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.percentuaisTemas,
          },
        ],
      };
    },
    openMaps() {
      window.open(this.payload.linkMaps, "_blank");
    },
    loadFirst() {
      this.loadCity();
      this.setConsultorCondutorMunicipio(this.$route.params.id);
      this.setConsultorEspecialistaMunicipio(this.$route.params.id);
      this.setAnalistaMunicipio(this.$route.params.id);
      this.setADMunicipio(this.$route.params.id);

      if (this.$store.state.uf === "SC") {
        this.medalWidth = "135px";
      }

      if (this.$store.state.uf !== "SC") {
        this.showMedalGrey = true;
      }

      document.getElementsByClassName("v-content__wrap")[0].style.background =
        "none";
    },
  },
  mounted() {
    this.loadFirst();
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isNA",
      "isIndicadores",
      "isAnalista",
      "isSala",
      "isFullAdmin",
      "isAT",
      "user",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
